import { useServices } from '../../../services/useServices';
import { usePipelineQuery } from './usePipelineQuery';

export const usePipelinesOverview = () => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'overview'],
    () => pipelines.getOverview()
  );
};
